import React from 'react'
import {MDBBox, MDBContainer} from "mdbreact";
import '../../pages/MobileNumberEntry/MobileNumberEntry.scss'
import {connect} from "react-redux";
import {setLoginStep, userLogin} from "../../Actions";
import LoginHeader from "../../component/LoginHeader/LoginHeader";
import {Slide} from "react-reveal";
import ScratchCard from 'react-scratch-coupon'
import './ScratchCardComponent.scss'
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import confetti from 'canvas-confetti'
import {assetUrl} from "../../serviceApi";

const whiteArrow = assetUrl+'images/white-arrow-right.png'
const cover = assetUrl+'images/scratch_cover.png'
const gift = assetUrl+'images/scratch_gift.png'

class ScratchCardComponent extends React.Component {
	state = {
		amt: 0,
		loading: false,
		open_modal: false,
		trigger: false,
		validated: false,
		touch: false
	}

	componentDidMount() {
		this.setState({...this.state, trigger: true});
	}


	rippleEffect = (e) => {
		if (this.state.validated === false) {

			let x = e.clientX;
			// let y = e.clientY;
			// let buttonTop = e.target.offsetTop;
			let buttonLeft = e.target.offsetLeft;
			let xInside = x - buttonLeft;
			// let yInside = y - buttonTop;

			let circle = document.createElement('span');
			circle.classList.add('mob-circle');
			// circle.style.top = yInside + 'px';
			circle.style.left = xInside + 'px';
			if (document.querySelector("#submitButton-mobile")) {

				document.querySelector("#submitButton-mobile").appendChild(circle);

				setTimeout(() => {

					circle.remove();

				}, 100);

			}
		}
	}

	handleSubmit = (e) => {
		this.rippleEffect(e);
		// this.props.setLoginStep(5);
		// this.props.handleLoginSteps(5);
		this.props.handleLoginSteps(0);
		this.props.setLoginStep(0);
		this.props.history.push("/home");
	}
	goToPreviousPage = () => {
		this.props.handleLoginSteps(0);
		this.props.setLoginStep(0);
	}

	toggleModal = () => {
		this.setState({
			open_modal: !this.state.open_modal
		});
	}

	render() {
		const styleMNE = "mob-entry-"

		if(this.state.touch){
			confetti()
		}


		return (

			<div className="scratch-component d-flex flex-column justify-content-between px-3 pt-4 pb-3">
				<MDBBox>
					<LoginHeader handleBackClick={this.goToPreviousPage}
					             handleCloseClick={this.goToPreviousPage}/>

					<div>
						<div className={"scratch-area py-3 px-2"} >

						{/*<Slide right cascade opposite when={this.state.trigger} >*/}
							<div>
								<div className={"scratch-card-wrap"} onTouchEnd={() => {

									return this.setState({...this.state, touch: true})
								}}>
									<div className={"scratch-card"}
									     >
										<ScratchCard width={"200px"} height={"200px"} cover={cover} style={{zIndex: 5}}>
											<div className={"gift-wrap"}>
												<img src={gift} alt={"alt"} className={"gift-image"}/>

											</div>
											<div className={"content-wrap"}>
												<p className={"gift-text my-0"}>You’ve won</p>
												<p className={"gift-amount my-0"}>₹ {this.props.user_details ? this.props.user_details.welcomeBonus : 50.0}</p>
											</div>

										</ScratchCard>
									</div>
								</div>
							</div>

						{/*</Slide>*/}
						</div>

						<MDBContainer fluid={true}>
							{/*<Slide right cascade opposite when={this.state.trigger}>*/}
								<div className={"my-3 text-center"}>
									<p className={styleMNE + 'heading text-center my-1'}>
										{!this.state.touch ? "Congratulations on setting up your account!" :

											this.state.touch ? "Congratulations!" : null}
									</p>

									<p className={ "scratch-subText my-1"}>
										{!this.state.touch ?"Scratch the above card by swiping on it.":"This will be added to your wallet"}
									</p>

								</div>

							{/*</Slide>*/}
						</MDBContainer>

					</div>

				</MDBBox>

				<div className={ 'buttonWrapper text-center mx-auto '}>
					<button
						className={styleMNE + "button btn  d-flex align-items-center justify-content-center my-1"}
						onClick={(e) => this.handleSubmit(e)}
						id={"submitButton-mobile"}
						disabled={this.state.loading}
					>
						<p className={"my-0 mx-2"}>Start Exploring</p>
						<img src={whiteArrow} alt={'alt'} className={styleMNE + "icon"}/>
					</button>

				</div>


			</div>
		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
})
const mapDispatchToProps = dispatch => ({
	addUserData: data => dispatch(userLogin(data)),
	setLoginStep: data => dispatch(setLoginStep(data))
})

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(ScratchCardComponent);


